module.exports = __webpack_public_path__ + "static/media/pipeline.e618e175.svg";